<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label">
  <div app-theme-option-content>
    <app-check [color]="color" [value]="themeOptions.options().gauge.pointer" (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-theme-option>